import { render, staticRenderFns } from "./statusbar.vue?vue&type=template&id=2abe78c3"
import script from "./statusbar.vue?vue&type=script&lang=js"
export * from "./statusbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports